export enum SavingState {
  BOTH,
  IMAGES,
  EXTERNAL_FILES,
  NOT_SAVING,
}

const getSavingState = (
  imagesSaving: boolean,
  externalFilesSaving: boolean,
): SavingState => {
  if (imagesSaving && externalFilesSaving) {
    return SavingState.BOTH;
  }

  if (imagesSaving) {
    return SavingState.IMAGES;
  }

  if (externalFilesSaving) {
    return SavingState.EXTERNAL_FILES;
  }

  return SavingState.NOT_SAVING;
};

export default getSavingState;
